<template>
  <div class="nf">
    <h1>404</h1>
    <p>Страница не найдена.</p>
    <RouterLink to="/">На главную</RouterLink>
  </div>
</template>

<style scoped>
.nf { padding: 48px; text-align: center; }
.nf h1 { font-size: 48px; margin-bottom: 8px; }
</style>
